import { render } from "./ImageAdditionalTag.vue?vue&type=template&id=72f4796a&scoped=true"
import script from "./ImageAdditionalTag.vue?vue&type=script&lang=js"
export * from "./ImageAdditionalTag.vue?vue&type=script&lang=js"

import "./ImageAdditionalTag.vue?vue&type=style&index=0&id=72f4796a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f4796a"]])

export default __exports__